import type { StudentPortfolioAssignmentShallowResource } from "api/generated";
import type {
  TeacherStudentAssignmentShallow,
  TeacherStudentTaskShallow,
} from "portfolio/types";
import { mapShallowTeacher } from "shared/mappers";
import { studentTagFromDto } from "portfolio/api/mappers/tag.mapper";

const mapTeacherStudentTaskShallow = (
  data: StudentPortfolioAssignmentShallowResource["task"],
): TeacherStudentTaskShallow => ({
  id: data.id,
  title: data.title,
  status: data.status,
  description: data.description,
  deadline: data.deadline ? new Date(data.deadline) : null,
  tags: data.tags.map(studentTagFromDto),
  isRequired: data.is_required,
  createdAt: data.created_at ? new Date(data.created_at) : null,
  user: mapShallowTeacher(data.user),
});

export const teacherStudentAssignmentShallowFromDto = (
  data: StudentPortfolioAssignmentShallowResource,
): TeacherStudentAssignmentShallow => ({
  id: data.id,
  status: data.status,
  concept: data.concept,
  assessmentStatus: data.assessment_status,
  gradeValue: data.grade_value ?? null,
  assessedByShortage: data.assessed_by_shortage ?? null,
  deadline: data.deadline ? new Date(data.deadline) : null,
  completedAt: data.completed_at ? new Date(data.completed_at) : null,
  task: mapTeacherStudentTaskShallow(data.task),
});
